import React from 'react';
import './styles.css';

const Heading = ({ children }) => {
  return <h1 className="Landing__Heading__root">{children}</h1>;
};

export default Heading;
